module.exports = __webpack_public_path__ + "static/image1-f5fb328f6e5ddf19ccfa3a435b8753e9.jpg";